import React from "react";
import Lottie from "lottie-react";
import mapAnim from "../anim/world-map-recolor.json";
import {FcVoicemail} from "react-icons/fc"

const Contact = () => {
  return (
    <div className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          Inquiries & Support
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
          Connect with us
        </h2>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-between gap-12 pb-16">
        {/* Contact Form Card */}
        <div className="w-full lg:w-1/2 flex justify-center" data-aos="fade-right">
          <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200/90 shadow-xl p-8 sm:p-10">
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-100">
              <div className="w-12 h-12 rounded-2xl bg-red-50 border border-red-100 flex items-center justify-center text-[#EB4438]">
                <FcVoicemail className="text-3xl" />
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-lg">Send a Message</h3>
                <p className="text-slate-400 text-xs">We typically respond within 24 hours</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="form-control">
                <label className="label py-1">
                  <span className="label-text font-semibold text-xs text-slate-700 uppercase tracking-wider">Name</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Name"
                  className="input input-bordered w-full rounded-xl bg-slate-50/50 border-slate-200 focus:border-[#EB4438] focus:bg-white text-sm"
                />
              </div>

              <div className="form-control">
                <label className="label py-1">
                  <span className="label-text font-semibold text-xs text-slate-700 uppercase tracking-wider">Email</span>
                </label>
                <input
                  type="email"
                  placeholder="Enter Your Email"
                  className="input input-bordered w-full rounded-xl bg-slate-50/50 border-slate-200 focus:border-[#EB4438] focus:bg-white text-sm"
                />
              </div>

              <div className="form-control">
                <label className="label py-1">
                  <span className="label-text font-semibold text-xs text-slate-700 uppercase tracking-wider">Message</span>
                </label>
                <textarea
                  placeholder="Enter Your Message"
                  rows={4}
                  className="textarea textarea-bordered w-full rounded-xl bg-slate-50/50 border-slate-200 focus:border-[#EB4438] focus:bg-white text-sm"
                />
              </div>

              <div className="form-control pt-2">
                <button className="w-full py-3.5 rounded-xl bg-[#EB4438] hover:bg-[#d9382c] text-white font-bold text-sm tracking-wide shadow-lg shadow-red-500/20 hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5">
                  SEND
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* World Map Animation */}
        <div className="w-full lg:w-1/2 flex items-center justify-center" data-aos="fade-left">
          <div className="w-full max-w-lg p-6 bg-slate-50 rounded-3xl border border-slate-200/70 shadow-sm">
            <Lottie animationData={mapAnim} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
